import React, {useContext, useEffect, useState} from 'react';
import ContentCard from './ContentCard';
import { UserContext } from '../contexts/user-context';
import { withTranslation, Trans } from 'react-i18next';

function UserVerifyCodeComponent(props) {

  const userContext = useContext(UserContext)

  const [allValues, setAllValues] = useState({
    confirmationCode: '',
  });

  const formClassName = userContext.errors != null ? 'mt-5' : 'mt-5 was-validated';
  const hasConfirmCodeErrors = (userContext.errors != null && userContext.errors.company_code != null);
  const confirmCodeInputClass = hasConfirmCodeErrors ? 'form-control is-invalid' : 'form-control';

  const changeHandler = e => {
    setAllValues({...allValues, [e.target.name]: e.target.value})
  }

  const inOutlook = false;
  const email = userContext.email
debugger
  return (
    <ContentCard title={<Trans i18nKey="confirm" />} text={<Trans i18nKey="confirm_explanation" />} >
      <form className={formClassName}
          onSubmit={(event) => {
            event.preventDefault()
            event.stopPropagation()
            userContext.confirmCode(allValues.confirmationCode, email, inOutlook)
          }}>
        <input type="hidden" name="authenticity_token" id="csrf-token" value={document.querySelector('[name=csrf-token]').content} />
        <div className="form-floating my-3" >
          <input
            type="text"
            name="confirmationCode"
            value={allValues.confirmationCode}
            onChange={changeHandler}
            className={confirmCodeInputClass}
            id="confirm_code"
            placeholder="" />
          <label htmlFor="confirm_code"><Trans i18nKey="confirmationCode" /></label>
        </div>

        {hasConfirmCodeErrors &&
          <div className="mt-4 mb-3 d-grid gap-2 col-9 mx-auto invalid-feedback">
            {userContext.errors.company_code.map((error) => (
              <span key={error}><Trans i18nKey={error} /></span>
            ))}
          </div>
        }
        <div className="mt-4 mb-3 d-grid gap-2 col-9 mx-auto">
          <button className="btn btn-primary btn-lg" type="submit">
            <i className="obn obn-privacy-2 me-2"></i><Trans i18nKey="confirm" />
          </button>
        </div>
      </form>
    </ContentCard>
  );
}

export default withTranslation()(UserVerifyCodeComponent);
